module.exports = __webpack_public_path__ + "img/ill_badge_profile_pin_lock.4e72f41b.svg";